<template>
    <kgr-profile-part v-if="!isEmpty">
        <template #heading>
            <div class="kgr-postfix kgr-postfix--center kgr-postfix--gutters kgr-row">
                <div class="kgr-postfix__fixed">
                    <h2 class="kgr-headline kgr-headline--h3">
                        {{ $t('Notizen zu {member}', {member: memberShortProfile.firstName}) }}
                    </h2>
                </div>
            </div>
        </template>

        <template #content>
            <table class="kgr-table">
                <tr
                    v-if="memberShortProfile.comment"
                    class="kgr-table__row kgr-table__row--top"
                >
                    <td
                        v-t="'memberShortProfile.comment'"
                        class="kgr-table__cell"
                    ></td>
                    <td class="kgr-table__cell">
                        {{ memberShortProfile.comment }}
                    </td>
                </tr>
                <tr
                    v-if="memberShortProfile.bookkeepingComment"
                    class="kgr-table__row kgr-table__row--top"
                >
                    <td
                        v-t="'memberShortProfile.bookkeepingComment'"
                        class="kgr-table__cell"
                    ></td>
                    <td class="kgr-table__cell">
                        {{ memberShortProfile.bookkeepingComment }}
                    </td>
                </tr>
            </table>
        </template>
    </kgr-profile-part>
</template>

<script>
import MemberShortProfile from '../../../js/dto/MemberShortProfile';
import ProfilePart from '../../short-profile/ProfilePart';

export default {
    name: 'kgr-member-part-comments',
    components: {
        'kgr-profile-part': ProfilePart,
    },
    props: {
        memberShortProfile: {
            type: MemberShortProfile,
            required: true,
        },
    },
    computed: {
        isEmpty() {
            return this.memberShortProfile.comment === '' && this.memberShortProfile.bookkeepingComment === '';
        }
    },
}
</script>
